import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import UnifiedCloudinaryForm from '@/components/UnifiedCloudinaryForm';
const ImageUrlEditField = ({ value, onChange, placeholder = 'url', disabled, }) => {
    const [editing, setEditing] = useState(false);
    const wrapperRef = useRef(null);
    // Закрытие формы при клике вне
    useEffect(() => {
        if (!editing)
            return;
        const handleClick = (e) => {
            // Для поддержки порталов/модалок внутри UnifiedCloudinaryForm
            const path = (e.composedPath && e.composedPath()) || [];
            // Не закрывать, если клик по модалке (data-cloudinary-modal)
            if (path.some((el) => el instanceof HTMLElement &&
                el.hasAttribute &&
                el.hasAttribute('data-cloudinary-modal'))) {
                return;
            }
            // Fallback: если composedPath не сработал (например, старый браузер или нестандартный портал)
            let node = e.target;
            while (node) {
                if (node.hasAttribute && node.hasAttribute('data-cloudinary-modal'))
                    return;
                node = node.parentElement;
            }
            if (wrapperRef.current && !path.includes(wrapperRef.current)) {
                setEditing(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [editing]);
    return (_jsx("div", { ref: wrapperRef, style: { position: 'relative', width: '100%' }, children: !editing ? (_jsx("div", { className: "inline-edit-display", onClick: () => !disabled && setEditing(true), onFocus: () => !disabled && setEditing(true), title: value, children: value ? value : _jsx("span", { className: "inline-edit-placeholder", children: placeholder }) })) : (_jsx(UnifiedCloudinaryForm, { defaultUrl: value, onUploaded: (data) => {
                onChange((data === null || data === void 0 ? void 0 : data.secure_url) || '');
                setEditing(false);
            } })) }));
};
export default ImageUrlEditField;
